export default __webpack_public_path__ + "static/media/clock.1f0e8ca3.svg";